// extracted by mini-css-extract-plugin
export default {"container":"Data_container__CQZCl","content":"Data_content__yTcG1","box":"Data_box__odd-Z"};